const t = ["base", "sm", "md", "lg", "xl", "2xl"], o = {
  base: "",
  sm: "sm:",
  md: "md:",
  lg: "lg:",
  xl: "xl:",
  "2xl": "2xl:"
};
function i(r, e) {
  return r == null ? [] : typeof r == "object" && !Array.isArray(r) ? t.flatMap((n) => {
    const s = r[n];
    return s == null ? [] : `${o[n]}${e(s)}`;
  }) : [e(r)];
}
export {
  i as r
};
